import React, { useState } from "react";
import clsx from "clsx";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import Button from "../../../components/button";
import API from "../../../api";
import { useNavigate } from "react-router";
import { connect } from "react-redux";
import { mapDispatchProps, mapStateToProps } from "../../../store/store";
import {
  SortableContainer,
  SortableElement,
  SortableHandle,
  SortEndHandler,
} from "react-sortable-hoc";
import { useLanguage } from '@languages/index';

interface Props {
  className?: string;
  onClick?: any;

  style?: any;
  onUpdate?: any;

  posting?: any;
  images?: any;

  auth?: any;
  showModal?: any;
  closeModal?: any;
}

interface SortableItemProps {
  value: any;
}

interface SortableListProps {
  items: any[];
  onSortEnd: SortEndHandler;
}

const DragHandle = SortableHandle(() => <span></span>);

const SortableItem = SortableElement<SortableItemProps>(({ value }) => {
  if (!value) return null;

  return (
    <div className="sortable-item">
      <img
        className="object-cover aspect-[0.7825]"
        key={`postingCardImage${value.id}`}
        src={value.thumbSmUrl}
      />
      <DragHandle />
    </div>
  );
});

const SortableList = SortableContainer<SortableListProps>(({ items }) => (
  <div className="grid grid-cols-5 grid-flow-row gap-[14px] w-full">
    {items.map((value, index) => (
      <SortableItem key={`item-${index}`} index={index} value={value} />
    ))}
  </div>
));

const SNSPostingImageOrderUpdate = (props: Props) => {
  const language = useLanguage();   
  const languageTexts = { ...language.common, ...language.pages.sns };
  let className = clsx(
    "order-update-modal",
    `flex flex-col`,
    `${props.className}`
  );

  const navigate = useNavigate();
  const [posting, setPosting] = useState<any>(props.posting);

  const onSortEnd = ({ oldIndex, newIndex }) => {
    setPosting((prevPosting) => {
      const newImages = [...prevPosting.images];
      const [movedItem] = newImages.splice(oldIndex, 1);
      newImages.splice(newIndex, 0, movedItem);
      return { ...prevPosting, images: newImages };
    });
  };

  const renderImages = () => {
    if (!posting) return null;
    const images = posting.images;
    return (
      <div className="image-container">
        <SortableList items={images} onSortEnd={onSortEnd} axis="xy" />
      </div>
    );
  };

  const fetchPosting = async () => {
    let fetchedPosting = null;
    await API.Post.show({
      brandToken: props.auth.token,
      postingId: props.posting.id,
    })
      .then((response: any) => {
        fetchedPosting = response.data.posting;
      })
      .catch((error) => {
        props.showModal({ text: error.message });
      });

    return fetchedPosting;
  };

  const updatePosting = (original) => {
    const newArr = [];

    posting.images.forEach((updatedImage) => {
      original.images.forEach((originalImage) => {
        if (originalImage.thumbSmUrl == updatedImage.thumbSmUrl) {
          newArr.push(originalImage);
        }
      });
    });

    const updated = { ...original, ...{ images: newArr } };
    API.SnsPosting.update({
      brandToken: props.auth.token,
      id: updated.id,
      posting: updated,
    })
      .then((response) => {
        props.showModal({ text: response.message });
        setPosting(response.data.posting);
        props.onUpdate ? props.onUpdate(response.data.posting) : null;
      })
      .catch((error) => {
        props.showModal({ text: error.message });
      });
  };

  const saveOrder = async () => {
    let fetchedPosting = await fetchPosting();
    if (fetchedPosting) await updatePosting(fetchedPosting);
  };

  return (
    <div
      className={className}
      style={props.style ? props.style : {}}
      onClick={() => (props.onClick ? props.onClick() : null)}
    >
      <div className="flex flex-col p-[35px] bg-white gap-[25px]">
        <div className="flex flex-row">{renderImages()}</div>
        <div className="flex flex-row gap-[5px]">
          <Button
            text={languageTexts.cancel}
            textColor={"BLACK"}
            buttonColor={"WHITE"}
            onClick={() => {
              props.closeModal();
            }}
          />
          <Button
            text={languageTexts.confirm}
            textColor={"WHITE"}
            buttonColor={"BLACK"}
            onClick={() => {
              saveOrder();
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default connect(
  mapStateToProps,
  mapDispatchProps
)(SNSPostingImageOrderUpdate);
